import React from 'react';
import { Table, Form, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TablaEmpresasYaProgramadas = ({
    candidatasPaginadas,
    licenciasSeleccionadas,
    todasSeleccionadasPaginaActual,
    toggleSeleccionarTodo,
    toggleSeleccion,
    cargando,
    formatearFechaLarga,
    formatearFechaCorta,
    copiarAlPortapapeles,
    toggleOrdenColumna,
    ordenDias,
    isAdmin = true
}) => (
    <>
        {/* Vista Móvil (Cards) */}
        <div className="d-md-none p-2">
            {isAdmin && candidatasPaginadas.length > 0 && (
                <div className="d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded border">
                    <Form.Check
                        type="checkbox"
                        id="select-all-mobile-programadas"
                        label={<span className="fs--1 fw-semi-bold">Seleccionar página</span>}
                        checked={todasSeleccionadasPaginaActual}
                        onChange={toggleSeleccionarTodo}
                        disabled={candidatasPaginadas.length === 0}
                    />
                    <span
                        className="cursor-pointer user-select-none text-primary fs--2 fw-semi-bold"
                        onClick={toggleOrdenColumna}
                    >
                        Vencimiento {ordenDias === 'DIAS_DESC' ? '↓' : '↑'}
                    </span>
                </div>
            )}
            {candidatasPaginadas.length > 0 ? (
                candidatasPaginadas.map((row, idx) => {
                    const isSelected = !!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia);
                    return (
                        <div
                            key={row.idLicencia || idx}
                            className={`card mb-2 shadow-none border ${isSelected ? 'border-primary bg-soft-primary-light' : ''}`}
                            style={{ borderRadius: '10px' }}
                        >
                            <div className="card-body p-3">
                                {/* Encabezado: Checkbox, ID y Badge tipo */}
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                        {isAdmin && (
                                            <Form.Check
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={() => toggleSeleccion(row)}
                                            />
                                        )}
                                        <Link to={"/licencias/detalle/" + row.idLicencia} className="fw-bold fs--1 text-900 text-decoration-none">
                                            ID: #{row.idLicencia}
                                        </Link>
                                    </div>
                                    <Badge
                                        bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                        className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                    >
                                        {row.vTipoLicencia || 'Desconocido'}
                                    </Badge>
                                </div>

                                {/* Empresa */}
                                <div className="mb-2">
                                    <div className="fw-bold fs--1 text-dark text-break">
                                        {row.vNombreEmpresa || 'Sin Nombre'}
                                    </div>
                                </div>

                                {/* Vencimiento y Fecha Programación */}
                                <div className="bg-light p-2 rounded mb-2 fs--2">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="text-600">Vencimiento:</span>
                                        <span className="fw-semi-bold text-700">{formatearFechaLarga(row.dFechaVencimiento)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="text-600">Días Vencidos:</span>
                                        <Badge bg="soft-danger" className="text-danger rounded-pill px-2 py-1">
                                            {row.iDiasVencidos} días
                                        </Badge>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="text-600">Programada el:</span>
                                        <span className="fw-semi-bold text-primary">{formatearFechaCorta(row.dFechaProgramacion)}</span>
                                    </div>
                                </div>

                                {/* Servidor / Base de Datos */}
                                <div className="mb-2 fs--2">
                                    <div className="text-600">
                                        <strong>Servidor:</strong> <span className="text-800">{row.vServer || 'N/A'}</span>
                                    </div>
                                    <div className="text-600">
                                        <strong>BD:</strong> <span className="text-800 fw-semi-bold">{row.vDatabase || 'N/A'}</span>
                                    </div>
                                </div>

                                {row.bTieneLicenciaVigente && (
                                    <div className="p-2 border border-warning rounded bg-white mb-2 fs--2">
                                        <div className="d-flex align-items-center gap-1 mb-1">
                                            <Badge bg="soft-warning" className="text-warning">
                                                Lic. Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                            </Badge>
                                            {(row.vServerVigente !== row.vServer || row.vDatabaseVigente !== row.vDatabase) && (
                                                <Badge bg="soft-info" className="text-info fs--2" title="La licencia activa está en otra BD o servidor diferente">
                                                    Otra BD
                                                </Badge>
                                            )}
                                        </div>
                                        <div className="text-800"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                        <div className="text-800"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                        {row.dFinLicenciaVigente && (
                                            <div className="text-600"><strong>Vence:</strong> {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                        )}
                                    </div>
                                )}

                                {/* UUID */}
                                <div className="d-flex justify-content-between align-items-center pt-2 border-top fs--2">
                                    <span className="text-muted">UUID:</span>
                                    <span
                                        className="text-primary font-monospace cursor-pointer text-truncate"
                                        style={{ maxWidth: '240px' }}
                                        onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                        title="Haz clic para copiar UUID"
                                    >
                                        <i className="far fa-copy me-1" />
                                        {row.vUUIDEmpresa || 'N/A'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="text-center py-4 text-muted fs--1">
                    {cargando ? 'Cargando datos...' : 'No hay empresas programadas para borrado.'}
                </div>
            )}
        </div>

        {/* Vista Escritorio (Tabla tradicional) */}
        <div className="table-responsive d-none d-md-block">
            <Table striped hover className="fs--1 mb-0 align-middle text-nowrap">
                <thead className="bg-200 text-900">
                    <tr>
                        {isAdmin && (
                            <th className="ps-2" style={{ width: '28px' }}>
                                <Form.Check
                                    type="checkbox"
                                    checked={todasSeleccionadasPaginaActual}
                                    onChange={toggleSeleccionarTodo}
                                    disabled={candidatasPaginadas.length === 0}
                                />
                            </th>
                        )}
                        <th>ID</th>
                        <th>Empresa</th>
                        <th>Tipo Licencia</th>
                        <th>Servidor / Base de Datos</th>
                        <th
                            className="cursor-pointer user-select-none text-primary"
                            onClick={toggleOrdenColumna}
                            title="Haz clic para alternar orden por días vencidos (Mayor / Menor)"
                        >
                            Vencimiento / Días {ordenDias === 'DIAS_DESC' ? '↓' : '↑'}
                        </th>
                        <th>Fecha en que se agregó</th>
                        <th className="pe-2">UUID Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    {candidatasPaginadas.length > 0 ? (
                        candidatasPaginadas.map((row, idx) => (
                            <tr key={row.idLicencia || idx}>
                                {isAdmin && (
                                    <td className="ps-2">
                                        <Form.Check
                                            type="checkbox"
                                            checked={!!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia)}
                                            onChange={() => toggleSeleccion(row)}
                                        />
                                    </td>
                                )}
                                <td>
                                    <Link to={"/licencias/detalle/" + row.idLicencia}>
                                        <strong>{row.idLicencia}</strong>
                                    </Link>
                                </td>
                                <td>
                                    <span className="d-inline-block text-truncate fs--1 text-800 fw-semi-bold" style={{ maxWidth: '220px' }}>
                                        {row.vNombreEmpresa || 'Sin Nombre'}
                                    </span>
                                </td>
                                <td>
                                    <Badge
                                        bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                        className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                    >
                                        {row.vTipoLicencia || 'Desconocido'}
                                    </Badge>
                                </td>
                                <td>
                                    <div>
                                        <div className="text-700 fs--2">{row.vServer || 'N/A'}</div>
                                        <div className="text-700 fs--2">{row.vDatabase || 'N/A'}</div>
                                    </div>
                                    {row.bTieneLicenciaVigente && (
                                        <div className="mt-1 p-1 px-2 border border-warning rounded bg-white">
                                            <div className="d-flex align-items-center gap-1 mb-1">
                                                <Badge bg="soft-warning" className="text-warning">
                                                    Lic. Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                                </Badge>
                                                {(row.vServerVigente !== row.vServer || row.vDatabaseVigente !== row.vDatabase) && (
                                                    <Badge bg="soft-info" className="text-info fs--2" title="La licencia activa está en otra BD o servidor diferente">
                                                        Otra BD
                                                    </Badge>
                                                )}
                                            </div>
                                            <div className="text-800 fs--2"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                            <div className="text-800 fs--2"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                            {row.dFinLicenciaVigente && (
                                                <div className="text-600 fs--2"><strong>Vence:</strong> {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                            )}
                                        </div>
                                    )}
                                </td>
                                <td>
                                    <div>
                                        <div className="fs--1 text-700">{formatearFechaLarga(row.dFechaVencimiento)}</div>
                                        <div className="mt-1">
                                            <Badge bg="soft-danger" className="text-danger rounded-pill px-2 py-1">
                                                {row.iDiasVencidos} días
                                            </Badge>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span className="fs--1 text-700">
                                        {formatearFechaCorta(row.dFechaProgramacion)}
                                    </span>
                                </td>
                                <td className="pe-2">
                                    <span
                                        className="text-700 fs--2 font-monospace cursor-pointer"
                                        onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                        title="Haz clic para copiar UUID"
                                    >
                                        {row.vUUIDEmpresa || 'N/A'}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={8} className="text-center py-4 text-muted fs--1">
                                {cargando ? 'Cargando datos...' : 'No hay empresas programadas para borrado.'}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    </>
);

export default TablaEmpresasYaProgramadas;
